// extracted by mini-css-extract-plugin
export var artDirected = "index-module--art-directed--b5947";
export var paginationCurrent = "index-module--pagination-current--7bb32";